module.exports = __webpack_public_path__ + "img/121ne.925760b5.svg";